// extracted by mini-css-extract-plugin
export default {"container":"tea-z","heading":"uea-z","links":"vea-z","linkBtn":"wea-z","disabled":"xea-z","linkUppercaseBold":"yea-z","copy":"zea-z","subCopy":"Aea-z"};